import { render } from "./PageView.vue?vue&type=template&id=a7e55cd0&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"

import "./PageView.vue?vue&type=style&index=0&id=a7e55cd0&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e55cd0"]])

export default __exports__